import { validateNumber } from 'ember-changeset-validations/validators';
import { isNumber } from 'lodash';
import type { IPOWorkbenchReportUrl } from 'volta/models/types/app-features';
import type { TFieldType } from 'volta/models/types/custom-field-definition';
import type { TCustomColumn } from 'volta/utils/column-utils';
import { tryParseURL } from 'volta/utils/text-utils';
import moment from 'moment-timezone';

export const CAMEL_CASE_REGEX = /^[a-z]+([A-Z][a-z]+)*$/;
export type ICustomColumnErrors = { index: number; message: string }[];
const checkCustomColumns = () => {
  return (_: string, columns: TCustomColumn[]) => {
    const checks: ICustomColumnErrors = [];

    if (columns?.length) {
      columns.forEach((c: TCustomColumn, index: number) => {
        if (!c.label || !c.path || !c.type) {
          checks.push({ index, message: 'empty' });
        }
        if (!CAMEL_CASE_REGEX.test(c.path)) {
          checks.push({ index, message: 'invalid' });
        }
      });
    }
    return checks.length === 0 || checks;
  };
};

export type IReportUrlErrors = { id: string; message: string }[];
const checkReportUrls = () => {
  return (_: string, poWorkbenchReportUrls: IPOWorkbenchReportUrl[]) => {
    const checks: IReportUrlErrors = [];

    if (poWorkbenchReportUrls) {
      poWorkbenchReportUrls.forEach(
        (poWorkbenchReportUrl: IPOWorkbenchReportUrl /*, index: number*/) => {
          if (poWorkbenchReportUrl.field) {
            if (!poWorkbenchReportUrl.reportUrl.href) {
              checks.push({ id: poWorkbenchReportUrl.id, message: 'empty' });
            }

            if (!tryParseURL(poWorkbenchReportUrl.reportUrl.href)) {
              checks.push({ id: poWorkbenchReportUrl.id, message: 'url' });
            }

            if (
              poWorkbenchReportUrls.filter(
                (i) =>
                  i.field === poWorkbenchReportUrl.field &&
                  i.fieldValue === poWorkbenchReportUrl.fieldValue
              ).length > 1
            ) {
              checks.push({
                id: poWorkbenchReportUrl.id,
                message: 'settingsPage.features.poWorkbench.reportUrls.duplicate'
              });
            }

            if (
              !checkFieldType(poWorkbenchReportUrl.fieldValue, poWorkbenchReportUrl.fieldValueType!)
            ) {
              checks.push({
                id: poWorkbenchReportUrl.id,
                message: 'settingsPage.features.poWorkbench.reportUrls.fieldType'
              });
            }
          }
        }
      );
    }
    return checks.length === 0 || checks;
  };
};

const checkFieldType = (value: string, fieldType: TFieldType) => {
  if (!value || !fieldType) {
    return true;
  }

  switch (fieldType) {
    case 'TEXT': {
      return typeof value === 'string';
    }
    case 'NUMBER': {
      return isNumber(value);
    }
    case 'BOOLEAN': {
      return value.toLowerCase() === 'true' || value.toLowerCase() === 'false';
    }
    case 'DATE': {
      return moment(value, 'DD/MM/YYYY', true).isValid();
    }
    default: {
      return true;
    }
  }
};

export default {
  execution: {
    customColumns: [checkCustomColumns()],
    projectionDltCount: [validateNumber({ positive: true, allowBlank: true })]
  },
  poWorkbench: {
    projectionMonths: [validateNumber({ gte: 1, lte: 36 })]
  },
  temp: {
    poWorkbenchReportUrls: [checkReportUrls()]
  }
};
